export const CDN_HOST = 'https://static-s.theckb.com';
export const STATIC_URL = {};


export const  myShopIcon:{[key:number]:string} = {
  1: 'https://static-s.theckb.com/BusinessMarket/OEM/shopIcon_base.png',
  4: 'https://static-s.theckb.com/BusinessMarket/OEM/shopIcon_amazon.png',
  2: 'https://static-s.theckb.com/BusinessMarket/OEM/shopIcon_shopify.png',
  0: 'https://static-s.theckb.com/BusinessMarket/OEM/shopIcon_ckb.png'
};